<template>
  <div class="lead">
    <div class="lead__sort-list">
      <div
        :class="[
          'lead__sort-item',
          'js-transition_item_common',
          { 'is-map': isMap() }
        ]"
        v-on:click="onClick($event)"
      >
        <span class="lead__sort-icon -arrow"><ArrowSVG></ArrowSVG></span>
        <span class="lead__sort-icon -sort js-sorticon"
          ><SortSVG></SortSVG
        ></span>
        <span class="lead__sort-txt">Sort</span>
      </div>
      <ToggleBtn :path-to-grand-child-prop="pathToChildProp"></ToggleBtn>
    </div>
  </div>
</template>

<script>
import ArrowSVG from "./assets/arrow.svg";
import SortSVG from "./assets/sort.svg";
import ToggleBtn from "./ToggleBtn/_index";
import orderBy from "lodash/orderBy";

export default {
  props: {
    pathToChildProp: {
      type: String,
      default: ""
    }
  },
  components: {
    ArrowSVG,
    SortSVG,
    ToggleBtn
  },
  data() {
    return {
      sortOrder: {
        name: "nameen"
      }
    };
  },
  methods: {
    onClick(e) {
      // icon
      const svg = e.currentTarget.querySelector(".js-sorticon");
      svg.classList.toggle("is-active");

      // sort
      this.clickSortByName();
    },
    clickSortByName() {
      const key = "nameen";
      this.reverseSortOrder(key);
      this.arraySortBy(key);
    },
    reverseSortOrder(key) {
      const sortOrder = { ...this.sortOrder };
      sortOrder[key] = this.sortOrder[key] === "desc" ? "asc" : "desc";
      this.sortOrder = sortOrder;
      this.$store.commit("sort", this.sortOrder[key] === "desc" ? true : false);
    },
    arraySortBy(key) {
      console.log(this.sortOrder);
      this.$store.state.member = orderBy(
        this.$store.state.member,
        [key],
        this.sortOrder[key]
      );
    },
    isMap() {
      return this.$route.path == "/map";
    }
  }
};
</script>

<style lang="scss" scoped>
.lead {
  // display: flex;
  // justify-content: flex-start;
  // align-items: flex-start;
  margin-top: 20px;
  display: inline-block;

  &__sort-list {
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }

  &__sort-item {
    font-weight: 700;
    color: #000;
    font-size: 16px;
    position: relative;
    cursor: pointer;

    &.is-map {
      opacity: 0;
      pointer-events: none;
    }

    display: flex;
    align-items: center;
    position: relative;

    .lead__sort-txt {
      position: relative;
      &:after {
        content: "";
        display: block;
        width: 100%;
        left: 0;
        bottom: 0;
        height: 1px;
        background: #707070;
        position: absolute;
        transform-origin: right;
        transform: scaleX(0);
        transition: transform 0.5s $easeOutExpo;
      }
    }

    @include min(769) {
      &:hover {
        .lead__sort-txt:after {
          transform-origin: left;
          transform: scaleX(1);
        }
      }
    }
  }

  &__sort-icon {
    &.-arrow {
      margin-right: 2px;
    }
    &.-sort {
      margin-right: 6px;

      &.is-active {
        svg {
          display: inline-block;
          transform-origin: 50% 50%;
          transform: scaleY(-1);
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Common/Lead/_index.vue